var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.id==13?'classify-block13':'classify-block'},[_c('div',{staticClass:"breadcrumb"},[_c('span',[_vm._v(_vm._s(_vm.mname))]),_vm._v(" > "),_c('span',[_vm._v(_vm._s(_vm.name))])]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }